import { useState } from 'react';
import TopBanner from './components/TopBanner';
import HeroAcelera from './components/HeroAcelera';
import PainAcelera from './components/PainAcelera';
import TransformAcelera from './components/TransformAcelera';
import AuthorityAcelera from './components/AuthorityAcelera';
import PartnersSection from '../aceleracao/components/PartnersSection';
import ClientsAcceleracao from '../aceleracao/components/ClientsAcceleracao';
import MethodSection from '../aceleracao/components/MethodSection';
import ResultadoPrevisivelAcelera from './components/ResultadoPrevisivelAcelera';
import QualificationSection from '../aceleracao/components/QualificationSection';
import ClosingSection from '../aceleracao/components/ClosingSection';
import LeadFormModal from '../aceleracao/components/LeadFormModal';
import Footer from '../../components/feature/Footer';

export default function AceleraPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <div className="min-h-screen">
      <TopBanner />
      <HeroAcelera onOpenModal={openModal} />
      <ClientsAcceleracao />
      <PainAcelera />
      <TransformAcelera onOpenModal={openModal} />
      <AuthorityAcelera />
      <PartnersSection />
      <MethodSection onOpenModal={openModal} />
      <ResultadoPrevisivelAcelera />
      <QualificationSection onOpenModal={openModal} />
      <ClosingSection onOpenModal={openModal} />
      <Footer onOpenModal={openModal} />
      
      <LeadFormModal isOpen={isModalOpen} onClose={closeModal} landingPage="acelera" />
    </div>
  );
}
